import { requestServices } from 'services';
import {
  IGetCategoryRequest,
  IGetCategoryResponse,
  IGetProductRequest,
  IGetProductResponse,
  IGetRoomInfoRequest,
  IGetRoomInfoResponse,
  ISaveOrderRequest,
} from 'interfaces';

// API doc: https://pos.dgl-dev.tekoapis.net/pos-bff/docs#/
const { pos365Client, getOnlyData } = requestServices;

const getCategory = async (
  params: IGetCategoryRequest
): Promise<IGetCategoryResponse> => {
  const response = await pos365Client.get('/pos-bff/category/', {
    params,
  });

  return getOnlyData(response.data);
};

const getProduct = async (
  params: IGetProductRequest
): Promise<IGetProductResponse> => {
  const response = await pos365Client.get('/pos-bff/product/', {
    params,
  });

  return getOnlyData(response.data);
};

const getRoomInfo = async (
  params: IGetRoomInfoRequest
): Promise<IGetRoomInfoResponse> => {
  const response = await pos365Client.get('/pos-bff/room/room-info', {
    params,
  });

  return getOnlyData(response.data);
};

const saveOrder = async (body: ISaveOrderRequest) => {
  const response = await pos365Client.post('/pos-bff/order/', body);

  return getOnlyData(response.data);
};

export default {
  getCategory,
  getProduct,
  getRoomInfo,
  saveOrder,
};
